import { useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

interface ToastOptions {
  message: string;
  type: 'success' | 'error';
  autoHideDuration?: number;
}

export const useToast = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [toastOptions, setToastOptions] = useState<ToastOptions | null>(null);

  const showToast = (message: string, type: 'success' | 'error', autoHideDuration?: number) => {
    setToastOptions({ message, type, autoHideDuration });
    setIsOpen(true);
  };

  const closeToast = () => {
    setIsOpen(false);
  };

  // Return an element (not a new component type each render) so parent re-renders
  // do not remount Snackbar and replay the open animation.
  const ToastComponent = (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={isOpen}
      autoHideDuration={toastOptions?.autoHideDuration || (toastOptions?.type === 'success' ? 1500 : 5000)}
      onClose={closeToast}
      message={toastOptions?.message}
    >
      <Alert onClose={closeToast} severity={toastOptions?.type} variant='filled' sx={{ width: '100%' }}>
        {toastOptions?.message}
      </Alert>
    </Snackbar>
  );

  return { showToast, ToastComponent };
};
